import { ThemeOverride, extendTheme } from '@chakra-ui/react';
import {
  Button,
  Input,
  Checkbox,
  Heading,
  Divider,
  Radio,
  Text,
} from './override';

export const themeColors = {
  cyan: {
    400: '#53BAD7',
  },
  blue: {
    600: '#25478F',
    800: '#0E2645',
  },
  gray: {
    50: '#E9EEF2',
    100: '#CBD9E2',
  },
  green: {
    500: '#4CAF50',
  },
  dynamic: {
    base: '#0E2645',
    baseOh: '#fff',
    accent: '#bc2d65',
    accentOh: '#fff',
    highlight: '#bc2d65',
    highlightOh: '#fff',
    complement: '#E9EEF2',
    complementOh: '#0E2645',
    font: '#0E2645',
  },
  zmyle: {
    primary: '#C02169',
    pink300: '#E83675',

    accent: '#bc2d65',
    highlight: '#bc2d65',
    shadow: '#000000',
  },
  error: {
    500: '#FC0106',
  },
} as const;

export type ThemeColors = {
  dynamic: Record<keyof typeof themeColors['dynamic'], string>;
};

const semanticTokens: ThemeOverride['semanticTokens'] = {
  colors: {
    text: {
      default: 'dynamic.font',
    },
  },
  sizes: {
    'max-giftcards-pages-main-sm': '40.625rem',
    'max-giftcards-pages-main-lg': '25.5rem',
  },
};

export const baseTheme: ThemeOverride = {
  colors: themeColors,
  semanticTokens,
  components: {
    Button,
    Input,
    Checkbox,
    Heading,
    Divider,
    Radio,
    Text,
  },
  shadows: {
    'dark-lg': '0 0 20px #0000004D',
    'giftcards-pages-main': '0 0 20px #0000004D',
    'shadow-button': '0 0 10px #00000066',
  },
  fonts: {
    heading: 'Roboto Slab, serif',
    body: 'Roboto, sans-serif',
    code: 'Source Code Pro, monospace',
  },
  styles: {
    global: {
      // disable view password button
      'input[type="password"]::-ms-reveal': {
        display: 'none',
        visibility: 'hidden',
      },
      'input[type="password"]::-ms-clear': {
        display: 'none',
        visibility: 'hidden',
      },
      'input[type="password"]::-webkit-search-decoration': {
        display: 'none',
        visibility: 'hidden',
      },
      'input[type="password"]::-webkit-search-cancel-button': {
        display: 'none',
        visibility: 'hidden',
      },
      'input[type="password"]::-webkit-search-results-button': {
        display: 'none',
        visibility: 'hidden',
      },
      'input[type="password"]::-webkit-search-results-decoration': {
        display: 'none',
        visibility: 'hidden',
      },

      body: {
        fontSize: '1rem',
        bg: 'dynamic.complement',
        color: 'dynamic.font',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      },
    },
  },
  breakpoints: {
    sm: '50rem',
    md: '64rem',
    lg: '90rem',
    xl: '120rem',
  },
};

export const fallbackTheme = extendTheme(baseTheme);

export default fallbackTheme;
